/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCoinRupee = createReactComponent("outline", "coin-rupee", "IconCoinRupee", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3", "key": "svg-1" }], ["path", { "d": "M9 11h6", "key": "svg-2" }]]);

export { IconCoinRupee as default };
//# sourceMappingURL=IconCoinRupee.mjs.map
